export default __webpack_public_path__ + "static/aws-cloud-migration-services-expense-363fdb1b3123e4cd216fa24e3884e5e5.svg";